import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameDetail extends BaseModelAPI {
	static entity = 'stockopnamedetail';
	static entityName = 'stockopnamedetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.stockOpnameId = '';
			this.stockOpname = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partLabel = '';
			this.partId = '';
			this.part = {};
			this.caseQty = 0;
			this.qtyActual = 0;
			this.remarks = '';
			this.scannedById = '';
			this.scannedBy = {};
			this.userIdCard = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}